import { useState } from 'react'
import { Popover } from 'antd'
import WizrButton from '../WizrButton'
import MoreIcon from '../../assets/icons/More'
import EditIcon from '../../assets/icons/EditIcon'
// import WizrFlexLayout from '../../stories/WizrFlexLayout/WizrFlexLayout'
import DeleteIcon from '../../assets/icons/DeleteIcon'
import { MODAL_TYPES, useWizrModalContext } from '../../providers/modal/WizrModalProvider'
import { dispatchDeleteScheduler, dispatchlistScheduler } from '../../redux/actions/content'
import styled from 'styled-components'
import WizrFlexLayout from '../WizrFlexLayout'
import { PaginationLimit } from '../../utils'
import HistoryIcon from '../../assets/icons/History'

const SchedulerPopover = ({ details, onClosePopover }: any): JSX.Element => {
  const schedulerId = details?.scheduler_id
  const { showModal, hideModal } = useWizrModalContext()

  const onEditAction = () => {
    onClosePopover?.()
    showModal(MODAL_TYPES.EDIT_SCHEDULE, {
      isEdit: true,
      editData: details,
      onCancel: hideModal
    })
  }
  const deleteTicket = async () => {
    hideModal()
    await dispatchDeleteScheduler(schedulerId)
    dispatchlistScheduler({ offset: 0, limit: PaginationLimit })
    hideModal()
  }

  const onDeleteAction = () => {
    onClosePopover?.()
    showModal(MODAL_TYPES.CONFIRMATION, {
      text: `Are you sure you want to delete ${details?.folder_name}?`,
      buttontext: "Confirm",
      onConfirm: deleteTicket,
      onCancel: hideModal

    })
  }

  const openHistoryPage = () => {
    window.open(`/scheduler/history/${schedulerId}`, '_blank'); // Opens the history page in a new tab
  };
  return (
    <WizrFlexLayout textAlign='left' background='#FFF'>

      <WizrButton
        icon={<EditIcon />}
        text='Edit'
        type='text'
        onClick={() => { onEditAction() }}
        justifyContent='flex-start'
      />
      <WizrButton
        icon={<DeleteIcon />}
        text='Delete'
        type='text'
        onClick={() => { onDeleteAction() }}
        justifyContent='flex-start'
      />
      <WizrButton
        icon={<HistoryIcon stroke="#1D1F22" />} // Use your history icon here
        text='History'
        type='text'
        onClick={openHistoryPage}
        justifyContent='flex-start'
      />
    </WizrFlexLayout>
  )
}

const SchedulerActionPopover = ({ details }: any): JSX.Element => {
  const [popoverOpen, setPopoverOpen] = useState(false)

  return (
    <Popover
      content={
        <SchedulerPopover
          details={details}
          onClosePopover={() => setPopoverOpen(false)}
        />
      }
      trigger='click'
      open={popoverOpen}
      onOpenChange={setPopoverOpen}
    >
      <StyledButton icon={<MoreIcon />} text='' type='text' style={{ height: '40px', width: '40px', borderRadius: '50px' }} />
    </Popover>
  )
}

export default SchedulerActionPopover

const StyledButton = styled(WizrButton)`
border-radius: 50%;
width: 20px;
height: 20px;
padding-right: 8px;
justify-content: center;
align-items: center;
  /* Default styles */
  path {
    stroke: #999B9F; /* Default stroke color */
    transition: stroke 0.3s ease; /* Smooth transition for color change */
  }

  /* Hover styles */
  &:hover path {
    stroke: #1D1F22
  }
`;
